/**
 * Invite to the Sorrem Discord, where alpha access is granted. Keep in sync
 * with `discordInviteUrl` in packages/website/src/lib/config.ts.
 */
export const DISCORD_INVITE_URL = 'https://discord.gg/6wSb5tffEr';
